import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=5845014e&scoped=true&"
import script from "./TransferModal.vue?vue&type=script&lang=js&"
export * from "./TransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5845014e",
  null
  
)

export default component.exports